import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=53f59cf1&scoped=true&"
import script from "./DocumentInput.vue?vue&type=script&lang=js&"
export * from "./DocumentInput.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInput.vue?vue&type=style&index=0&id=53f59cf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f59cf1",
  null
  
)

export default component.exports